import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface MovieGridSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  moreLink?: string;
}

export default function MovieGridSection({
  title,
  subtitle,
  movies,
  moreLink,
}: MovieGridSectionProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <SectionHeading title={title} subtitle={subtitle} moreLink={moreLink} />
        {movies.length === 0 ? (
          <div className="py-16 text-center text-foreground-400 text-sm">
            暂无相关影视内容，建议尝试搜索或浏览其他分类
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {movies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}